import IsMobile from 'ismobilejs'
import * as CssSupport from './utils/CssSupport'
import {
  GetRenderSide,
  HasTransform,
  Has3DTransform,
  IsClientSide,
  IsCSS1Compat,
  IsDesktop,
  IsIe8,
  IsLocalHost,
  IsMobile as IsMobileType,
  IsPhone,
  IsServerSide,
  IsTablet,
  SupportPageOffset
} from './EnvHelper.types'

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class EnvHelper {
  static getRenderSide: GetRenderSide = () => (
    typeof window === 'undefined' ? 'server' : 'client'
  )

  static isServerSide: IsServerSide = () => (
    EnvHelper.getRenderSide() === 'server'
  )

  static isClientSide: IsClientSide = () => (
    EnvHelper.getRenderSide() === 'client'
  )

  static isLocalHost: IsLocalHost = () => (
    EnvHelper.isClientSide() &&
    window.location.hostname.includes('localhost')
  )

  static isIe8: IsIe8 = () => (
    EnvHelper.isClientSide() &&
    document.querySelector('html')?.className?.includes('ie8')
  )

  static isTablet: IsTablet = () => IsMobile().tablet
  static isPhone: IsPhone = () => IsMobile().phone
  static isMobile: IsMobileType = () => IsMobile().any
  static isDesktop: IsDesktop = () => !IsMobile().any

  static hasTransform: HasTransform = () => (
    EnvHelper.isClientSide() &&
    CssSupport.cssProperty('transform')
  )

  static has3DTransform: Has3DTransform = () => (
    EnvHelper.isClientSide() &&
    CssSupport.cssProperty('perspective')
  )

  static supportPageOffset: SupportPageOffset = () => (
    EnvHelper.isClientSide() &&
    window.pageXOffset !== undefined
  )

  static isCSS1Compat: IsCSS1Compat = () => (
    EnvHelper.isClientSide() &&
    document?.compatMode === 'CSS1Compat'
  )
}
